export default __webpack_public_path__ + "static/media/bahía_gif_over.57c6815a.gif";